/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumMessageChannel = "chat" | "email" | "fax" | "inapp" | "sms" | "voice" | "whatsapp" | "%future added value";
export type EnumMessageClassification = "irregular" | "negative" | "positive" | "recognizedKeywords" | "unclassified" | "%future added value";
export type EnumMessageExternalIdSource = "awsses" | "bandwidth" | "interfax" | "mandrill" | "nexmo" | "plivo" | "ringcentral" | "sendgrid" | "twilio" | "%future added value";
export type EnumMessageMentionsRef = "group" | "user" | "%future added value";
export type EnumMessageNotifyToChannel = "chat" | "email" | "fax" | "inapp" | "sms" | "voice" | "whatsapp" | "%future added value";
export type EnumMessageRecipientType = "doctor" | "patient" | "staff" | "%future added value";
export type EnumMessageRef = "appointmentOffer" | "botFollowup" | "broadcast" | "chat" | "chatAudit" | "chatAuditTz" | "chatNotification" | "feedback" | "feedbackReminder" | "followup" | "formReminder" | "generic" | "outboundReferralOutreach" | "outboundReferralReminder" | "pinVerification" | "referralFollowup" | "referralRedirect" | "referralReminder" | "reminder" | "reschedule" | "stop" | "telehealth" | "waitingRoomPatient" | "waitlist" | "waitlistOffer" | "%future added value";
export type EnumMessageStatus = "delivered" | "opened" | "pending" | "sent" | "skipped" | "undelivered" | "%future added value";
export type EnumMessageType = "inbound" | "outbound" | "%future added value";
export type EnumMessageVisibility = "internal" | "private" | "public" | "%future added value";
export type EnumMessageVoiceAnsweredBy = "fax" | "human" | "machineEndBeep" | "machineEndOther" | "machineEndSilence" | "machineStart" | "unknown" | "%future added value";
export type FilterFindManyMessageInput = {
    user?: string | null | undefined;
    _id?: string | null | undefined;
    deleted?: number | null | undefined;
    createdAt?: unknown | null | undefined;
    updatedAt?: unknown | null | undefined;
    createdBy?: string | null | undefined;
    updatedBy?: string | null | undefined;
    deletedBy?: string | null | undefined;
    deletedAt?: unknown | null | undefined;
    patient?: string | null | undefined;
    key?: string | null | undefined;
    from?: string | null | undefined;
    to?: string | null | undefined;
    type?: EnumMessageType | null | undefined;
    voiceAnsweredBy?: EnumMessageVoiceAnsweredBy | null | undefined;
    ref?: EnumMessageRef | null | undefined;
    refId?: string | null | undefined;
    patientMessageTemplate?: string | null | undefined;
    outboundMessage?: string | null | undefined;
    status?: EnumMessageStatus | null | undefined;
    statusReason?: string | null | undefined;
    skippedStatusReason?: string | null | undefined;
    language?: string | null | undefined;
    externalStatus?: MessageExternalStatusInput | null | undefined;
    channel?: EnumMessageChannel | null | undefined;
    text?: string | null | undefined;
    classification?: EnumMessageClassification | null | undefined;
    externalId?: MessageExternalIdInput | null | undefined;
    secure?: boolean | null | undefined;
    automated?: boolean | null | undefined;
    visibility?: EnumMessageVisibility | null | undefined;
    file?: string | null | undefined;
    media?: MessageMediaInput | null | undefined;
    stats?: MessageStatsInput | null | undefined;
    retry?: MessageRetryInput | null | undefined;
    terminatingStateAt?: unknown | null | undefined;
    mentions?: Array<MessageMentionsInput | null> | null | undefined;
    recipient?: string | null | undefined;
    recipientType?: EnumMessageRecipientType | null | undefined;
    notifyTo?: Array<MessageNotifyToInput | null> | null | undefined;
    shouldForceContactWithNotifyTo?: boolean | null | undefined;
    appointment?: string | null | undefined;
    provider?: string | null | undefined;
    appointmentType?: string | null | undefined;
    followup?: string | null | undefined;
    recall?: string | null | undefined;
    referral?: string | null | undefined;
    messageFailure?: string | null | undefined;
    _ids?: Array<string | null> | null | undefined;
    _operators?: OperatorsFilterFindManyMessageInput | null | undefined;
    OR?: Array<FilterFindManyMessageInput> | null | undefined;
    AND?: Array<FilterFindManyMessageInput> | null | undefined;
};
export type MessageExternalStatusInput = {
    code?: string | null | undefined;
    reason?: string | null | undefined;
};
export type MessageExternalIdInput = {
    source?: EnumMessageExternalIdSource | null | undefined;
    value?: string | null | undefined;
};
export type MessageMediaInput = {
    url?: string | null | undefined;
    contentType?: string | null | undefined;
    _id?: string | null | undefined;
};
export type MessageStatsInput = {
    timers?: MessageStatsTimersInput | null | undefined;
    pricing?: MessageStatsPricingInput | null | undefined;
};
export type MessageStatsTimersInput = {
    elapsedReplyTime?: number | null | undefined;
    _id?: string | null | undefined;
};
export type MessageStatsPricingInput = {
    segments?: number | null | undefined;
    carrierFee?: number | null | undefined;
    baseRate?: number | null | undefined;
    _id?: string | null | undefined;
};
export type MessageRetryInput = {
    originalMessage?: string | null | undefined;
    count?: number | null | undefined;
};
export type MessageMentionsInput = {
    ref?: EnumMessageMentionsRef | null | undefined;
    refId?: string | null | undefined;
    mention?: string | null | undefined;
    _id?: string | null | undefined;
};
export type MessageNotifyToInput = {
    channel?: EnumMessageNotifyToChannel | null | undefined;
    to?: string | null | undefined;
};
export type OperatorsFilterFindManyMessageInput = {
    user?: UserOperatorsFilterFindManyMessageInput | null | undefined;
    _id?: _idOperatorsFilterFindManyMessageInput | null | undefined;
    deleted?: DeletedOperatorsFilterFindManyMessageInput | null | undefined;
    createdAt?: CreatedAtOperatorsFilterFindManyMessageInput | null | undefined;
    updatedAt?: UpdatedAtOperatorsFilterFindManyMessageInput | null | undefined;
    createdBy?: CreatedByOperatorsFilterFindManyMessageInput | null | undefined;
    updatedBy?: UpdatedByOperatorsFilterFindManyMessageInput | null | undefined;
    deletedBy?: DeletedByOperatorsFilterFindManyMessageInput | null | undefined;
    deletedAt?: DeletedAtOperatorsFilterFindManyMessageInput | null | undefined;
    patient?: PatientOperatorsFilterFindManyMessageInput | null | undefined;
    key?: KeyOperatorsFilterFindManyMessageInput | null | undefined;
    from?: FromOperatorsFilterFindManyMessageInput | null | undefined;
    to?: ToOperatorsFilterFindManyMessageInput | null | undefined;
    type?: TypeOperatorsFilterFindManyMessageInput | null | undefined;
    voiceAnsweredBy?: VoiceAnsweredByOperatorsFilterFindManyMessageInput | null | undefined;
    ref?: RefOperatorsFilterFindManyMessageInput | null | undefined;
    refId?: RefIdOperatorsFilterFindManyMessageInput | null | undefined;
    patientMessageTemplate?: PatientMessageTemplateOperatorsFilterFindManyMessageInput | null | undefined;
    outboundMessage?: OutboundMessageOperatorsFilterFindManyMessageInput | null | undefined;
    status?: StatusOperatorsFilterFindManyMessageInput | null | undefined;
    statusReason?: StatusReasonOperatorsFilterFindManyMessageInput | null | undefined;
    skippedStatusReason?: SkippedStatusReasonOperatorsFilterFindManyMessageInput | null | undefined;
    language?: LanguageOperatorsFilterFindManyMessageInput | null | undefined;
    externalStatus?: ExternalStatusOperatorsFilterFindManyMessageInput | null | undefined;
    channel?: ChannelOperatorsFilterFindManyMessageInput | null | undefined;
    text?: TextOperatorsFilterFindManyMessageInput | null | undefined;
    classification?: ClassificationOperatorsFilterFindManyMessageInput | null | undefined;
    externalId?: ExternalIdOperatorsFilterFindManyMessageInput | null | undefined;
    secure?: SecureOperatorsFilterFindManyMessageInput | null | undefined;
    automated?: AutomatedOperatorsFilterFindManyMessageInput | null | undefined;
    visibility?: VisibilityOperatorsFilterFindManyMessageInput | null | undefined;
    file?: FileOperatorsFilterFindManyMessageInput | null | undefined;
    media?: MediaOperatorsFilterFindManyMessageInput | null | undefined;
    stats?: StatsOperatorsFilterFindManyMessageInput | null | undefined;
    retry?: RetryOperatorsFilterFindManyMessageInput | null | undefined;
    terminatingStateAt?: TerminatingStateAtOperatorsFilterFindManyMessageInput | null | undefined;
    mentions?: MentionsOperatorsFilterFindManyMessageInput | null | undefined;
    recipient?: RecipientOperatorsFilterFindManyMessageInput | null | undefined;
    recipientType?: RecipientTypeOperatorsFilterFindManyMessageInput | null | undefined;
    notifyTo?: NotifyToOperatorsFilterFindManyMessageInput | null | undefined;
    shouldForceContactWithNotifyTo?: ShouldForceContactWithNotifyToOperatorsFilterFindManyMessageInput | null | undefined;
    appointment?: AppointmentOperatorsFilterFindManyMessageInput | null | undefined;
    provider?: ProviderOperatorsFilterFindManyMessageInput | null | undefined;
    appointmentType?: AppointmentTypeOperatorsFilterFindManyMessageInput | null | undefined;
    followup?: FollowupOperatorsFilterFindManyMessageInput | null | undefined;
    recall?: RecallOperatorsFilterFindManyMessageInput | null | undefined;
    referral?: ReferralOperatorsFilterFindManyMessageInput | null | undefined;
    messageFailure?: MessageFailureOperatorsFilterFindManyMessageInput | null | undefined;
};
export type UserOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type _idOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedOperatorsFilterFindManyMessageInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type CreatedAtOperatorsFilterFindManyMessageInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type UpdatedAtOperatorsFilterFindManyMessageInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type CreatedByOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type UpdatedByOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedByOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedAtOperatorsFilterFindManyMessageInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type PatientOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type KeyOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type FromOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type ToOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type TypeOperatorsFilterFindManyMessageInput = {
    gt?: EnumMessageType | null | undefined;
    gte?: EnumMessageType | null | undefined;
    lt?: EnumMessageType | null | undefined;
    lte?: EnumMessageType | null | undefined;
    ne?: EnumMessageType | null | undefined;
    in?: Array<EnumMessageType | null> | null | undefined;
    nin?: Array<EnumMessageType | null> | null | undefined;
    regex?: EnumMessageType | null | undefined;
};
export type VoiceAnsweredByOperatorsFilterFindManyMessageInput = {
    gt?: EnumMessageVoiceAnsweredBy | null | undefined;
    gte?: EnumMessageVoiceAnsweredBy | null | undefined;
    lt?: EnumMessageVoiceAnsweredBy | null | undefined;
    lte?: EnumMessageVoiceAnsweredBy | null | undefined;
    ne?: EnumMessageVoiceAnsweredBy | null | undefined;
    in?: Array<EnumMessageVoiceAnsweredBy | null> | null | undefined;
    nin?: Array<EnumMessageVoiceAnsweredBy | null> | null | undefined;
    regex?: EnumMessageVoiceAnsweredBy | null | undefined;
};
export type RefOperatorsFilterFindManyMessageInput = {
    gt?: EnumMessageRef | null | undefined;
    gte?: EnumMessageRef | null | undefined;
    lt?: EnumMessageRef | null | undefined;
    lte?: EnumMessageRef | null | undefined;
    ne?: EnumMessageRef | null | undefined;
    in?: Array<EnumMessageRef | null> | null | undefined;
    nin?: Array<EnumMessageRef | null> | null | undefined;
    regex?: EnumMessageRef | null | undefined;
};
export type RefIdOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PatientMessageTemplateOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type OutboundMessageOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type StatusOperatorsFilterFindManyMessageInput = {
    gt?: EnumMessageStatus | null | undefined;
    gte?: EnumMessageStatus | null | undefined;
    lt?: EnumMessageStatus | null | undefined;
    lte?: EnumMessageStatus | null | undefined;
    ne?: EnumMessageStatus | null | undefined;
    in?: Array<EnumMessageStatus | null> | null | undefined;
    nin?: Array<EnumMessageStatus | null> | null | undefined;
    regex?: EnumMessageStatus | null | undefined;
};
export type StatusReasonOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type SkippedStatusReasonOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type LanguageOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type ExternalStatusOperatorsFilterFindManyMessageInput = {
    gt?: MessageExternalStatusInput | null | undefined;
    gte?: MessageExternalStatusInput | null | undefined;
    lt?: MessageExternalStatusInput | null | undefined;
    lte?: MessageExternalStatusInput | null | undefined;
    ne?: MessageExternalStatusInput | null | undefined;
    in?: Array<MessageExternalStatusInput | null> | null | undefined;
    nin?: Array<MessageExternalStatusInput | null> | null | undefined;
    regex?: MessageExternalStatusInput | null | undefined;
};
export type ChannelOperatorsFilterFindManyMessageInput = {
    gt?: EnumMessageChannel | null | undefined;
    gte?: EnumMessageChannel | null | undefined;
    lt?: EnumMessageChannel | null | undefined;
    lte?: EnumMessageChannel | null | undefined;
    ne?: EnumMessageChannel | null | undefined;
    in?: Array<EnumMessageChannel | null> | null | undefined;
    nin?: Array<EnumMessageChannel | null> | null | undefined;
    regex?: EnumMessageChannel | null | undefined;
};
export type TextOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type ClassificationOperatorsFilterFindManyMessageInput = {
    gt?: EnumMessageClassification | null | undefined;
    gte?: EnumMessageClassification | null | undefined;
    lt?: EnumMessageClassification | null | undefined;
    lte?: EnumMessageClassification | null | undefined;
    ne?: EnumMessageClassification | null | undefined;
    in?: Array<EnumMessageClassification | null> | null | undefined;
    nin?: Array<EnumMessageClassification | null> | null | undefined;
    regex?: EnumMessageClassification | null | undefined;
};
export type ExternalIdOperatorsFilterFindManyMessageInput = {
    gt?: MessageExternalIdInput | null | undefined;
    gte?: MessageExternalIdInput | null | undefined;
    lt?: MessageExternalIdInput | null | undefined;
    lte?: MessageExternalIdInput | null | undefined;
    ne?: MessageExternalIdInput | null | undefined;
    in?: Array<MessageExternalIdInput | null> | null | undefined;
    nin?: Array<MessageExternalIdInput | null> | null | undefined;
    regex?: MessageExternalIdInput | null | undefined;
};
export type SecureOperatorsFilterFindManyMessageInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type AutomatedOperatorsFilterFindManyMessageInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type VisibilityOperatorsFilterFindManyMessageInput = {
    gt?: EnumMessageVisibility | null | undefined;
    gte?: EnumMessageVisibility | null | undefined;
    lt?: EnumMessageVisibility | null | undefined;
    lte?: EnumMessageVisibility | null | undefined;
    ne?: EnumMessageVisibility | null | undefined;
    in?: Array<EnumMessageVisibility | null> | null | undefined;
    nin?: Array<EnumMessageVisibility | null> | null | undefined;
    regex?: EnumMessageVisibility | null | undefined;
};
export type FileOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type MediaOperatorsFilterFindManyMessageInput = {
    gt?: MessageMediaInput | null | undefined;
    gte?: MessageMediaInput | null | undefined;
    lt?: MessageMediaInput | null | undefined;
    lte?: MessageMediaInput | null | undefined;
    ne?: MessageMediaInput | null | undefined;
    in?: Array<MessageMediaInput | null> | null | undefined;
    nin?: Array<MessageMediaInput | null> | null | undefined;
    regex?: MessageMediaInput | null | undefined;
};
export type StatsOperatorsFilterFindManyMessageInput = {
    gt?: MessageStatsInput | null | undefined;
    gte?: MessageStatsInput | null | undefined;
    lt?: MessageStatsInput | null | undefined;
    lte?: MessageStatsInput | null | undefined;
    ne?: MessageStatsInput | null | undefined;
    in?: Array<MessageStatsInput | null> | null | undefined;
    nin?: Array<MessageStatsInput | null> | null | undefined;
    regex?: MessageStatsInput | null | undefined;
};
export type RetryOperatorsFilterFindManyMessageInput = {
    gt?: MessageRetryInput | null | undefined;
    gte?: MessageRetryInput | null | undefined;
    lt?: MessageRetryInput | null | undefined;
    lte?: MessageRetryInput | null | undefined;
    ne?: MessageRetryInput | null | undefined;
    in?: Array<MessageRetryInput | null> | null | undefined;
    nin?: Array<MessageRetryInput | null> | null | undefined;
    regex?: MessageRetryInput | null | undefined;
};
export type TerminatingStateAtOperatorsFilterFindManyMessageInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type MentionsOperatorsFilterFindManyMessageInput = {
    gt?: MessageMentionsInput | null | undefined;
    gte?: MessageMentionsInput | null | undefined;
    lt?: MessageMentionsInput | null | undefined;
    lte?: MessageMentionsInput | null | undefined;
    ne?: MessageMentionsInput | null | undefined;
    in?: Array<MessageMentionsInput | null> | null | undefined;
    nin?: Array<MessageMentionsInput | null> | null | undefined;
    regex?: MessageMentionsInput | null | undefined;
};
export type RecipientOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type RecipientTypeOperatorsFilterFindManyMessageInput = {
    gt?: EnumMessageRecipientType | null | undefined;
    gte?: EnumMessageRecipientType | null | undefined;
    lt?: EnumMessageRecipientType | null | undefined;
    lte?: EnumMessageRecipientType | null | undefined;
    ne?: EnumMessageRecipientType | null | undefined;
    in?: Array<EnumMessageRecipientType | null> | null | undefined;
    nin?: Array<EnumMessageRecipientType | null> | null | undefined;
    regex?: EnumMessageRecipientType | null | undefined;
};
export type NotifyToOperatorsFilterFindManyMessageInput = {
    gt?: MessageNotifyToInput | null | undefined;
    gte?: MessageNotifyToInput | null | undefined;
    lt?: MessageNotifyToInput | null | undefined;
    lte?: MessageNotifyToInput | null | undefined;
    ne?: MessageNotifyToInput | null | undefined;
    in?: Array<MessageNotifyToInput | null> | null | undefined;
    nin?: Array<MessageNotifyToInput | null> | null | undefined;
    regex?: MessageNotifyToInput | null | undefined;
};
export type ShouldForceContactWithNotifyToOperatorsFilterFindManyMessageInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type AppointmentOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type ProviderOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type AppointmentTypeOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type FollowupOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type RecallOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type ReferralOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type MessageFailureOperatorsFilterFindManyMessageInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type QueryTableMessagesEmbedQueryVariables = {
    filter?: FilterFindManyMessageInput | null | undefined;
};
export type QueryTableMessagesEmbedQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"TableMessages_EmbedQuery">;
};
export type QueryTableMessagesEmbedQuery = {
    readonly response: QueryTableMessagesEmbedQueryResponse;
    readonly variables: QueryTableMessagesEmbedQueryVariables;
};



/*
query QueryTableMessagesEmbedQuery(
  $filter: FilterFindManyMessageInput
) {
  ...TableMessages_EmbedQuery_Vt7Yj
}

fragment IconMessageStatus_EmbedMessage on Message {
  status
  statusReason
  externalStatus {
    reason
  }
}

fragment TableMessages_EmbedQuery_Vt7Yj on Query {
  messageConnection(first: 15, sort: _ID_DESC, filter: $filter) {
    edges {
      node {
        _id
        ...TableRowMessage_EmbedMessage
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment TableRowMessage_EmbedMessage on Message {
  _id
  createdAt
  patient {
    _id
    name
    id
  }
  from
  to
  ...TypographyMessageText_EmbedMessage
  ...TypographyMessageChannel_EmbedMessage
  ...TypographyMessageRef_EmbedMessage
  ...IconMessageStatus_EmbedMessage
}

fragment TypographyMessageChannel_EmbedMessage on Message {
  channel
}

fragment TypographyMessageRef_EmbedMessage on Message {
  ref
}

fragment TypographyMessageText_EmbedMessage on Message {
  text
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = {
  "kind": "Variable",
  "name": "filter",
  "variableName": "filter"
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 15
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "_ID_DESC"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QueryTableMessagesEmbedQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "TableMessages_EmbedQuery"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QueryTableMessagesEmbedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "MessageConnection",
        "kind": "LinkedField",
        "name": "messageConnection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MessageEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Message",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Patient",
                    "kind": "LinkedField",
                    "name": "patient",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "from",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "to",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "text",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "channel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ref",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "statusReason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MessageExternalStatus",
                    "kind": "LinkedField",
                    "name": "externalStatus",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "reason",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": [
          "sort",
          "filter"
        ],
        "handle": "connection",
        "key": "TableMessages_Embed_messageConnection",
        "kind": "LinkedHandle",
        "name": "messageConnection"
      }
    ]
  },
  "params": {
    "cacheID": "d9b5bc6a3cd1b60b213289c330598a6b",
    "id": null,
    "metadata": {},
    "name": "QueryTableMessagesEmbedQuery",
    "operationKind": "query",
    "text": "query QueryTableMessagesEmbedQuery(\n  $filter: FilterFindManyMessageInput\n) {\n  ...TableMessages_EmbedQuery_Vt7Yj\n}\n\nfragment IconMessageStatus_EmbedMessage on Message {\n  status\n  statusReason\n  externalStatus {\n    reason\n  }\n}\n\nfragment TableMessages_EmbedQuery_Vt7Yj on Query {\n  messageConnection(first: 15, sort: _ID_DESC, filter: $filter) {\n    edges {\n      node {\n        _id\n        ...TableRowMessage_EmbedMessage\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment TableRowMessage_EmbedMessage on Message {\n  _id\n  createdAt\n  patient {\n    _id\n    name\n    id\n  }\n  from\n  to\n  ...TypographyMessageText_EmbedMessage\n  ...TypographyMessageChannel_EmbedMessage\n  ...TypographyMessageRef_EmbedMessage\n  ...IconMessageStatus_EmbedMessage\n}\n\nfragment TypographyMessageChannel_EmbedMessage on Message {\n  channel\n}\n\nfragment TypographyMessageRef_EmbedMessage on Message {\n  ref\n}\n\nfragment TypographyMessageText_EmbedMessage on Message {\n  text\n}\n"
  }
};
})();
(node as any).hash = '28dee9db99af9fde3d44ea7c0dba402f';
export default node;
